import dotenv from "dotenv";
import { Button as MaterialUiButton, Checkbox, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { DropzoneDialog } from "material-ui-dropzone";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row, Table, Modal } from "react-bootstrap";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import Creatable from "react-select/creatable";
import Tooltip from "react-tooltip-lite";
import { v4 as uuidv4 } from "uuid";
import { listGroups } from "../actions/groupActions";
import { listProducts } from "../actions/productActions";
import {
  listRequestDetails,
  sendMailRequest,
  approveRequest,
  commentRequest,
  withdrawRequest,
  updateRequest
} from "../actions/requestActions";
import { listUsersForEcr } from "../actions/userActions";
import CommentBox from "../components/CommentBox";
import FormContainer from "../components/FormContainer";
import Loader from "../components/Loader";
import Message from "../components/Message";
import {
  REQUEST_APPROVE_RESET,
  REQUEST_DETAILS_RESET,
  REQUEST_WITHDRAW_RESET,
  REQUEST_UPDATE_RESET,
  REQUEST_SEND_MAIL_RESET
} from "../constants/requestConstants";
import ModalForm from "../components/ModalForm";
import ToolTip from "../components/ToolTip";
import { REQUEST_PHASES } from "../constants/RequestPhases";

dotenv.config()

// using material-ui core styles
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  form: {
    width: "300%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const RequestEditScreen = ({ match, history }) => {
  const classes = useStyles();
  const requestId = match.params.id;

  // Input Fields (Data to get/post)
  const [title, setTitle] = useState("");
  const [problemStatement, setProblemStatement] = useState("");
  const [changesRequired, setChangesRequired] = useState("");
  const [productsAffected, setProductsAffected] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [progress, setProgress] = useState({});
  const [ehaComments, setEhaComments] = useState("");
  const [saComments, setSaComments] = useState("");
  const [ccComments, setCcComments] = useState("");
  const [engineeringValidationComments, setEngineeringValidationComments] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [ecrChampion, setEcrChampion] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [comments, setComments] = useState([]);
  const [taskFields, setTaskFields] = useState([]);
  const [docSpecFields, setDocSpecFields] = useState([]);
  const [filesInfo, setFilesInfo] = useState([]);
  const [sendMail, setSendMail] = useState(false);

  // 
  const [open, setOpen] = React.useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [validated, setValidated] = useState(false);
  const [taskListError, setTaskListError] = useState("");
  const [action, setAction] = useState({error: "", message: ""})
  const dispatch = useDispatch();
  const formElement = useRef();

  const { userInfo } = useSelector((state) => state.userLogin);

  // Form Checks
  // taskFieldsCheck for assign handler
  const taskFieldsCheck = taskFields.length && taskFields.every(({taskAssigned, taskDetails})=> taskAssigned.length && taskDetails);
  const taskListCompletionCheck = progress.currentStep === 1 ? true : taskFields.length && taskFields.every(({completed}) => completed);
  const approveButtonCheck = (userInfo?.isAdmin || (userInfo?._id === ecrChampion && progress.currentStep===2)) && (taskListCompletionCheck && progress.currentStep < 5 && progress.currentStep > 0);
  const withdrawButtonCheck = userInfo?.isAdmin && (progress.currentStep > 1 && progress.currentStep !== 6);
  const activeStep =
    progress && Array.isArray(progress.steps)
      ? progress.steps[progress.currentStep]
      : null;
  const formValidationCheck = () => {
    if(!(formElement.current.checkValidity() && ecrChampion)){
      setValidated(true);
      setAction({error: "Please fill all the fields!"});
      setTimeout(setAction, 3000);
      return false;
    }
    return true;
  }

  const fileExtensions = /docx|pdf|csv|xlsx|png|jpg|jpeg/;
  const serverURL = process.env.NODE_ENV==='development' ? 'http://localhost:5000/api/files/download/' : 'https://ec.unirac.com/api/files/download/';

  const uploadFileHandler = async (files) => {
    const formData = new FormData();
    let filesList = [];
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
      let splittedFile=files[i].name.split('.');
      splittedFile[1]=splittedFile[1].toLowerCase();
      let file=splittedFile.join('.');
      if (!file.match(fileExtensions)) {
        setFileUploadError(`${files[i].name} is not supported!`);
        setTimeout(() => setFileUploadError(""), 3000);
      } else filesList.push(files[i].name);
    }
    setUploading(true);

    try {
      if (filesList.length) {
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        const { data } = await axios.post("/api/upload", formData, config);

        setFilesInfo(
          [...filesInfo].concat(
            data.files.map(({ id, filename }) => {
              return {
                uuid: uuidv4(),
                id,
                filename,
                fileUrl: `${process.env.REACT_APP_BASE_URL}/files/download/${filename}`,
              };
            })
          )
        );
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const uploadFileHandlerCustom = async (e, id) => {
    const files = e.target.files;
    const formData = new FormData();
    let filesList = [];
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
      filesList.push(files[i].name);
    }
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await axios.post("/api/upload", formData, config);

      const newInputFields = docSpecFields.map((i) => {
        if (id === i.id) {
          i["file"] = data.files[0];
        }
        return i;
      });
      setDocSpecFields(newInputFields);

      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  // convert to ISO Date
  const convertISODate = (mydate) => {
    const date = new Date(mydate);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }

    return month + "/" + dt + "/" + year;
  };

  // For Tasks
  const handleChangeTaskInput = (id, event) => {
    const newInputFields = taskFields.map((i) => {
      if (id === i.id) {
        if (event.target !== null && event.target.id === "completed") {
          i["completed"] = !i["completed"];
        } else i[event.target.name] = event.target.value;
      }
      return i;
    });
    setTaskFields(newInputFields);
  };

  const handleAddTaskFields = () => {
    setTaskFields([
      ...taskFields,
      {
        id: uuidv4(),
        // taskAssigned: userInitial,
        taskAssigned: [],
        taskDetails: "",
        completed: false,
      },
    ]);
  };

  const handleRemoveTaskFields = (id) => {
    const values = [...taskFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setTaskFields(values);
  };

  const handleUpdateTaskFields = (tasks) => {
    let myTasks = [];
    const taskList = Array.isArray(tasks) ? tasks : [];

    taskList.forEach(({ assignedTo, details, completed }) => {
      let assignedUsersAndGroups = [];
      const assignedUsers =
        assignedTo && Array.isArray(assignedTo.users) ? assignedTo.users : [];
      const assignedGroups =
        assignedTo && Array.isArray(assignedTo.groups) ? assignedTo.groups : [];

      if (usersList.length > 0 && assignedUsers.length > 0) {
        usersList.forEach((u) => {
          assignedUsers.forEach((a) => {
            const assignedUserId = a && (a._id || a.id) ? a._id || a.id : a;
            if (String(assignedUserId) === String(u.value)) {
              assignedUsersAndGroups.push(u);
            }
          });
        });
      }
      if (groupsList.length > 0 && assignedGroups.length > 0) {
        groupsList.forEach((u) => {
          assignedGroups.forEach((a) => {
            const assignedGroupId = a && (a._id || a.id) ? a._id || a.id : a;
            if (String(assignedGroupId) === String(u.value)) {
              assignedUsersAndGroups.push(u);
            }
          });
        });
      }

      myTasks.push({
        id: uuidv4(),
        taskAssigned: assignedUsersAndGroups,
        taskDetails: details,
        completed,
      });
    });

    setTaskFields(myTasks);
  };

  // for files attached
  const handleUpdateFileInfoFields = (files) => {
    let myFiles = [];
    files.forEach(({ _id, filename }) => {
      myFiles.push({
        uuid: uuidv4(),
        id: _id,
        filename,
        fileUrl: `${process.env.REACT_APP_BASE_URL}/files/download/${filename}`,
      });
    });
    setFilesInfo(myFiles);
  };

  const handleRemoveFileInfoFields = (uuid) => {
    const values = [...filesInfo];
    values.splice(
      values.findIndex((value) => value.uuid === uuid),
      1
    );
    setFilesInfo(values);
  };

  // For Document Specifications
  const handleUpdateDocSpecFields = (docs) => {
    let myDocs = [];
    docs.forEach(({ documentChangedFrom, documentChangedTo, file }) => {
      myDocs.push({
        id: uuidv4(),
        documentChangedFrom,
        documentChangedTo,
        file,
      });
    });
    setDocSpecFields(myDocs);
  };

  const handleChangeDocSpecInput = (id, event) => {
    const newInputFields = docSpecFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setDocSpecFields(newInputFields);
  };

  const handleAddDocSpecFields = () => {
    setDocSpecFields([
      ...docSpecFields,
      {
        id: uuidv4(),
        documentChangedFrom: "",
        documentChangedTo: "",
        file: { id: "", filename: "" },
      },
    ]);
  };

  const handleRemoveDocSpecFields = (id) => {
    const values = [...docSpecFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setDocSpecFields(values);
  };

  const handleOnchange = (val) => {
    setProductsAffected(val.split(","));
  };


  const requestDetails = useSelector((state) => state.requestDetails);
  const { loading, error, request } = requestDetails;
  const requestActionId = request && request._id;

  const requestUpdate = useSelector((state) => state.requestUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = requestUpdate;

  const userListForEcr = useSelector((state) => state.userListForEcr);
  const {
    loading: loadingUserList,
    error: errorUserList,
    users,
    success: successUserListUpdate,
  } = userListForEcr;

  const groupList = useSelector((state) => state.groupList);

  const {
    loading: loadingGroupList,
    error: errorGroupList,
    groups,
    success: successGroupListUpdate,
  } = groupList;

  let userInitial = [];
  let usersList = [];
  if (users && users.length > 0) {
    usersList = users.map((u) => {
      return {
        value: u._id,
        label: u.name + "-" + u.email,
        option: "users",
      };
    });
    userInitial = ecrChampion;
  }

  let groupsList = [];
  if (groups && groups.length > 0) {
    groupsList = groups.map((u) => {
      return {
        value: u._id,
        label: u.name,
        option: "groups",
      };
    });
  }

  const productList = useSelector((state) => state.productList);
  const {
    loading: loadingProducts,
    error: errorProducts,
    products,
  } = productList;

  let productOptions = [];
  let productsInitial = [];
  if (products && products.length > 0) {
    productOptions = products.map((p) => {
      return {
        label: p.name,
        value: p._id,
        style: {
          color: "blue",
        },
      };
    });
    productsInitial = productsAffected;
  }

  // grouped Options
  const groupedOptions = [
    {
      label: "Groups",
      options: groupsList && groupsList.length > 0 ? groupsList : [],
    },
    {
      label: "Users",
      options: usersList,
    },
  ];

  useEffect(setValidated, [])

  useEffect(() => {
    if (userInfo) {
      if (
        users &&
        groups &&
        products &&
        users.length == 0 &&
        groups.length == 0 &&
        products.length == 0
      ) {
        dispatch(listUsersForEcr());
        dispatch(listGroups("", "", false));
        dispatch(listProducts("", "", false));
      }
    }
    if (successUpdate) {
      dispatch({ type: REQUEST_UPDATE_RESET });
      dispatch({ type: REQUEST_DETAILS_RESET });
    } else {
      if (!request || request._id !== requestId) {
        dispatch(listRequestDetails(requestId));
      } else {
        setTitle(request.title || "");
        setChangesRequired(request.changesRequired || "");
        setProblemStatement(request.problemStatement || "");
        setProductsAffected(Array.isArray(request.productsAffected) ? request.productsAffected : []);
        setProgress(request.progress || {});
        const tasks =
          request.tasksProgress && Array.isArray(request.tasksProgress.tasks)
            ? request.tasksProgress.tasks
            : [];
        if (tasks.length > 0) {
          handleUpdateTaskFields(tasks);
        } else {
          setTaskFields([]);
        }

        let comments = [];
        const steps =
          request.progress && Array.isArray(request.progress.steps)
            ? request.progress.steps
            : [];
        steps.forEach((step) => {
          const stepComments = Array.isArray(step.comments) ? step.comments : [];
          if (stepComments.length > 0) {
            stepComments.forEach((comment) => {
              let userLabel = "";
              if (usersList.length > 0) {
                const commentUserId =
                  comment.user && (comment.user._id || comment.user.id)
                    ? comment.user._id || comment.user.id
                    : comment.user;
                let user = usersList.find(
                  (u) => String(u.value) === String(commentUserId)
                );
                userLabel = user ? user.label : "";
              }
              comments.push({
                userLabel: userLabel,
                name: step.name || "",
                ...comment,
              });
            });
          }
        });
        setComments(comments);
        setEhaComments(request.ehaComments || "");
        setSaComments(request.saComments || "");
        setCcComments(request.ccComments || "");
        setEngineeringValidationComments(request.engineeringValidationComments || "");
        setCreatedAt(request.createdAt ? convertISODate(request.createdAt) : "");
        setEcrChampion(request.ecrChampion || []);
        setIsSubmitted(Boolean(request.isSubmitted));
        if (request.filesAttached && request.filesAttached.length > 0) {
          handleUpdateFileInfoFields(request.filesAttached);
        } else {
          setFilesInfo([]);
        }
        if (
          request.documentSpecifications &&
          request.documentSpecifications.length > 0
        ) {
          handleUpdateDocSpecFields(request.documentSpecifications);
        } else {
          setDocSpecFields([]);
        }

        sendMail && dispatch(sendMailRequest({ _id: request._id, ecrId: request.ecrId, title, initiatedBy: request.initiatedBy, ecrChampion, tasksProgress: request.tasksProgress }));
        setSendMail(false);
      }
    }
  }, [
    requestId,
    request,
    successUpdate,
    successUserListUpdate,
    successGroupListUpdate,
    userInfo,
  ]);

  const [, setRequestId] = useState(""); // need not extract requestId as it's match.params.id
  const [withdrawModalShow, setWithdrawModalShow] = useState(false);
  const [approveModalShow, setApproveModalShow] = useState(false);
  const [commentsModalShow, setCommentsModalShow] = useState(false);
  const [withdrawNote, setWithdrawNote] = useState("");
  const [commentNote, setCommentNote] = useState("");
  const [approveNote, setApproveNote] = useState("");

  const requestWithdraw = useSelector((state) => state.requestWithdraw);
  const { success: successRequestWithdraw, requestDetails: withdrawedRequest } = requestWithdraw;

  const requestApprove = useSelector((state) => state.requestApprove);
  const { success: successRequestApprove, requestDetails: approvedRequest } = requestApprove;

  const requestComment = useSelector((state) => state.requestComment);
  const { success: successRequestComment } = requestComment;

  const { loading: loadingMailRequest, success: successMailRequest, mailResponse } = useSelector(state => state.requestMail)

  useEffect(() => {
    if (successRequestApprove) {
      dispatch({ type: REQUEST_APPROVE_RESET });
      setProgress(approvedRequest.progress);
    }

    if (successRequestWithdraw) {
      dispatch({ type: REQUEST_WITHDRAW_RESET });
      setProgress(withdrawedRequest.progress);
    }

    if (successRequestComment) {
      dispatch({ type: REQUEST_WITHDRAW_RESET });
    }

    if(successMailRequest){
      dispatch({ type: REQUEST_SEND_MAIL_RESET });
      setAction({message: 'Mail sent!'});
      setTimeout(setAction, 3000);
    }
  }, [
    successRequestApprove,
    successRequestComment,
    successRequestWithdraw,
    successMailRequest
  ]);

  // Action Hanlders (save, submit, assign, approve, withdraw)
  const saveRequest = async (isSubmittedValue) => {
    await updateRequest({
      title,
      changesRequired,
      problemStatement,
      productsAffected,
      newComment,
      ehaComments,
      saComments,
      ccComments,
      engineeringValidationComments,
      ecrChampion,
      taskFields,
      docSpecFields,
      filesAttached: filesInfo.map(({id}) => id),
      ...(isSubmitted ? {} : {isSubmitted: isSubmittedValue}),
    }, requestId);
    setNewComment("");
    setValidated(false);
  }

  const saveHandler = async () => {
    if(formValidationCheck()) {
      await saveRequest();
      setAction({ message: "ECR is saved!🎉" });
      setTimeout(setAction, 3000);
    }
  }

  const submitHandler = async () => {
    if(formValidationCheck()) {
      await saveRequest(true);
      setAction({ message: "ECR is submitted!🎉" })
      setTimeout(setAction, 3000);
    }
  };

  const assignHandler = async () => {
    await saveHandler();
    setSendMail(true);
    // dispatch(sendMailRequest({ _id: request._id, ecrId: request.ecrId, title, initiatedBy: request.initiatedBy, ecrChampion, tasksProgress: request.tasksProgress }));
    setAction({ message: "Mail Sent!🎉" })
    setTimeout(setAction, 3000);
  };

  const approveModalHandler = (id) => {
    setRequestId(id);
    setApproveModalShow(true);
  };

  const approveHandler = async () => {
    await saveHandler();
    dispatch(
      approveRequest({
        _id: requestId,
        comment: approveNote,
        action: "Approve",
      })
    );
    setApproveModalShow(false);
  }

  const withdrawModalHandler = (id) => {
    setRequestId(id);
    setWithdrawModalShow(true);
  };

  const withdrawHandler = async () => {
    await saveHandler();
    dispatch(
      withdrawRequest({
        _id: requestId,
        comment: withdrawNote,
        action: "Withdraw",
      })
    );
    setWithdrawModalShow(false);
  }

  const commentsModalHandler = (id) => {
    setRequestId(id);
    setCommentsModalShow(true);
  };

  const commentsHandler = async () => {
    await saveHandler();
    dispatch(
      commentRequest({
        _id: requestId,
        comment: commentRequest,
        action: "Further Comments",
      })
    );
    setCommentsModalShow(false);
  }

  const emailToTaskHolder = (taskAssigned, taskDetails) => {
    if (requestActionId) {
      dispatch(sendMailRequest({ _id: requestActionId, ecrId: request.ecrId, title, taskAssigned, taskDetails }))
    }
  }

  return (
    <div id="requestEditScreen">
      <button onClick={history.goBack} className="btn btn-light my-3">
        Go Back
      </button>
      <FormContainer>
        <h1>EDIT ECR (ENGINEERING CHANGE REQUEST)</h1>
        {loadingUpdate ? <Loader /> : null}
        {errorUpdate ? <Message variant="danger">{errorUpdate}</Message> : null}
        {loading ? <Loader /> :
        error ? <Message variant="danger">{error}</Message> : null}
          <Form noValidate validated={validated} ref={formElement}>
            {request && request.ecrId ? (
              <Row>
                <Col>
                  <Form.Group
                    className="formgroup"
                    controlId="ecrID"
                  >
                    <Form.Label>ECR ID</Form.Label>
                    <Form.Control
                      style={{ color: "black", fontSize: "1rem" }}
                      readOnly
                      type="string"
                      value={request.ecrId}
                    />
                  </Form.Group>
                </Col>
                <Col></Col>
              </Row>
            ) : null}
            <Row>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="createdAt"
                >
                  <Form.Label>Initiation Date</Form.Label>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    readOnly
                    type="string"
                    value={createdAt}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="title"
                >
                  <Form.Label>Title
                    <ToolTip description="A one-liner on why this ECR is being created" />
                  </Form.Label>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    as="textarea"
                    rows={2}
                    type="name"
                    placeholder="Enter Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter title.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="problemStatement"
                >
                  <Form.Label>Problem Statement (Current Condition)
                    <ToolTip description="A summary of the problem that has led to the creation of the ECR" />
                  </Form.Label>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    type="name"
                    as="textarea"
                    rows={3}
                    placeholder="Enter Problem Statement"
                    value={problemStatement}
                    onChange={(e) => setProblemStatement(e.target.value)}
                    required
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter problem statement.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="changesRequired"
                >
                  <Form.Label>Changes Required (Detailed Description)
                    <ToolTip description="List all drawings/ documents affected by the proposed change. Also include the detailed list of changes" />
                  </Form.Label>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    type="name"
                    as="textarea"
                    rows={3}
                    placeholder="Enter Changes Required"
                    value={changesRequired}
                    onChange={(e) => setChangesRequired(e.target.value)}
                    required
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter changes required.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="productsAffected"
                >
                  <Form.Label style={{ color: "black", fontSize: "1.2rem" }}>
                    Products Affected
                  </Form.Label>
                  <MultiSelect
                    style={{ width: "100%" }}
                    defaultValue={productsInitial}
                    onChange={handleOnchange}
                    options={productOptions}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="ecrChampion"
                >
                  <Form.Label style={{ color: "black", fontSize: "1.2rem" }}>
                    ECR Champion
                    <ToolTip description="Person handling the ECR" />
                  </Form.Label>
                  <MultiSelect
                    style={{ width: "100%" }}
                    name="ecrChampion"
                    defaultValue={userInitial}
                    onChange={isSubmitted && !userInfo?.isAdmin ? ()=>{} : setEcrChampion}
                    options={usersList}
                    singleSelect={true}
                    disabled={!userInfo?.isAdmin}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="ehaformBasicCheckbox"
                >
                  <div className="label-Tooltip">
                     <Form.Label style={{ color: "black", fontSize: "1.2rem" }}>
                      Environmental Health Assessment
                      <ToolTip description="Check the box and fill in the appropriate health assessments for the change." />
                    </Form.Label>
                  </div>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    type="name"
                    as="textarea"
                    rows={2}
                    placeholder="Enter Environmental Health Assessment"
                    value={ehaComments}
                    onChange={(e) => setEhaComments(e.target.value)}
                    required
                  >
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter EHA comments.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="saformBasicCheckbox"
                >
                  <div className="label-Tooltip">
                    <Form.Label style={{ color: "black", fontSize: "1.2rem" }}>
                      Safety Assessment
                      <ToolTip description="Check the box and fill in the appropriate safety assessments for the change." />
                    </Form.Label>
                  </div>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    type="name"
                    as="textarea"
                    rows={2}
                    placeholder="Enter Safety Assessment"
                    value={saComments}
                    onChange={(e) => setSaComments(e.target.value)}
                    required
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter Safety Assessment comments.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
              <Form.Group
                  className="formgroup"
                  controlId="ccformBasicCheckbox"
                >
                  <div className="label-Tooltip">
                    <Form.Label style={{ color: "black", fontSize: "1.2rem" }}>
                      Certification Consideration
                      <ToolTip description="Check the box and fill in the appropriate considerations for the change. If unsure, talk to the certification engineer before submitting"/>
                    </Form.Label>
                  </div>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    type="name"
                    as="textarea"
                    rows={2}
                    placeholder="Enter Certification Considerations"
                    value={ccComments}
                    onChange={(e) => setCcComments(e.target.value)}
                    required
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please enter Certification Consideration comments.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="formgroup"
                >
                  <Row className="align-items-center">
                    <Col>
                      <Form.Label className="additionalDetailFilesLabel">Additional Detail Files
                        <ToolTip description="Include redlined drawings/ documents if required" />
                      </Form.Label>
                      <h6>{`.doc & .xls files aren't supported`}</h6>
                    </Col>
                    <Col className="text-right">
                      <div>
                        <MaterialUiButton
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setOpen(true);
                          }}
                        >
                          Add Files
                        </MaterialUiButton>
                        <DropzoneDialog
                          filesLimit={10}
                          acceptedFiles={[
                            ".docx",
                            ".pdf",
                            ".csv",
                            ".xlsx",
                            ".png",
                            ".jpg",
                            ".jpeg",
                          ]}
                          cancelButtonText={"cancel"}
                          submitButtonText={"submit"}
                          maxFileSize={50000000}
                          open={open}
                          onClose={() => setOpen(false)}
                          onSave={(files) => {
                            uploadFileHandler(files);
                            setOpen(false);
                          }}
                          showPreviews={true}
                          showFileNamesInPreview={true}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ textAlign: "center",marginRight:"-10px",marginLeft:"-10px" }}>
                    <Table bordered hover responsive className="table-sm">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>FILE NAME</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fileUploadError ? <p>{fileUploadError}</p> : null}
                        {filesInfo && filesInfo.length > 0
                          ? filesInfo.map((inputField, index) => (
                              <tr key={inputField.id}>
                                <td>{index + 1}</td>
                                <td>
                                  <a
                                    href={serverURL + encodeURIComponent(inputField.filename)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                  >
                                    {inputField.filename}
                                  </a>
                                </td>
                                <td>
                                  <Button
                                    variant="danger"
                                    className="btn-sm mx-1 my-1"
                                    onClick={() =>
                                      handleRemoveFileInfoFields(
                                        inputField.uuid
                                      )
                                    }
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </Table>
                  </Row>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="formgroup"
                  controlId="newComment"
                >
                  <Form.Label>Add Comment</Form.Label>
                  <Form.Control
                    style={{ color: "black", fontSize: "1rem" }}
                    type="name"
                    as="textarea"
                    rows={2}
                    placeholder="Enter Comments"
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                  ></Form.Control>
                  {comments.map(
                    ({_id, commentedAt, comment, userLabel, action, name}) =>
                      <CommentBox
                        style={{ marginBottom: "10px" }}
                        key={_id}
                        time={commentedAt}
                        comment={comment}
                        user={userLabel}
                        action={action}
                        phase={name}
                      />
                  )}
                </Form.Group>
              </Col>
              <Col>
                  <Form.Group
                    className="formgroup"
                    controlId="evformBasicCheckbox"
                  >
                    <div className="label-Tooltip">
                      <Form.Label style={{ color: "black", fontSize: "1.2rem" }}>
                        Engineering Validation
                        <ToolTip description="Check the box and fill in the appropriate validations for the change. If unsure, talk to the engineer before submitting"/>
                      </Form.Label>
                    </div>
                    <Form.Control
                      style={{ color: "black", fontSize: "1rem" }}
                      type="name"
                      as="textarea"
                      rows={2}
                      placeholder="Enter Engineering Validation"
                      value={engineeringValidationComments}
                      onChange={(e) => setEngineeringValidationComments(e.target.value)}
                      required
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please enter Engineering Validation comments.
                    </Form.Control.Feedback>
                  </Form.Group>
              </Col>
            </Row>
            {isSubmitted && progress.currentStep > 1 ? (
              <Form.Group
                className="formgroup"
              >
                <Row className="align-items-center">
                  <Col>
                    <Form.Label>Task List
                      <ToolTip description="Add tasks for each individual whose effort is required in moving ahead with this change and also explain what the task is under task detail" />
                    </Form.Label>
                  </Col>
                  <Col className="text-right">
                    <Button className="my-3" onClick={handleAddTaskFields}>
                      <i className="fas fa-plus"></i>Add New Task
                    </Button>
                  </Col>
                </Row>
                <Row style={{ textAlign: "center",marginRight:"-10px",marginLeft:"-10px" }}>
                  <Table bordered hover responsive className="table-sm">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>TASK GROUP</th>
                        <th>TASK DETAIL</th>
                        <th>COMPLETED</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskFields.length > 0
                        ? taskFields.map((inputField, index) => (
                            <tr key={inputField.id}>
                              <td>{index + 1}</td>
                              <td>
                                <Creatable
                                  name="taskAssigned"
                                  classNamePrefix="select"
                                  name="color"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                  onChange={(event) =>
                                    handleChangeTaskInput(inputField.id, {
                                      target: {
                                        name: "taskAssigned",
                                        value: event,
                                      },
                                    })
                                  }
                                  isMulti
                                  options={groupedOptions}
                                  defaultValue={inputField.taskAssigned}
                                />
                              </td>
                              <td>
                                <TextField
                                  style={{ width: "100%" }}
                                  name="taskDetails"
                                  label="Task Details"
                                  maxRows={3}
                                  multiline
                                  id="standard-basic"
                                  value={inputField.taskDetails}
                                  onChange={(event) =>
                                    handleChangeTaskInput(inputField.id, event)
                                  }
                                />
                              </td>
                              <td>
                                <Checkbox
                                  id="completed"
                                  color="primary"
                                  checked={inputField.taskDetails==="" || inputField.taskAssigned.length===0?false:inputField.completed}
                                  onChange={(event) =>
                                    handleChangeTaskInput(inputField.id, event)
                                  }
                                  disabled={inputField.taskDetails==="" || inputField.taskAssigned.length===0}
                                />
                              </td>
                              <td>
                                <Button
                                  variant="danger"
                                  className="btn-sm mx-1 my-1"
                                  onClick={() =>
                                    handleRemoveTaskFields(inputField.id)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </Button>
                                <Button
                                  onClick={()=>emailToTaskHolder(inputField.taskAssigned, inputField.taskDetails)}
                                  className="btn-sm mx-1 my-1"
                                >
                                  <i className="fas fa-envelope"></i>
                                </Button>
                              </td>
                            </tr>
                          ))
                        : null}
                    </tbody>
                  </Table>
                </Row>
                <p className="taskListError">{taskListError}</p>
              </Form.Group>
            ) : null}
            {isSubmitted ? (
              <Form.Group
                className="formgroup"
              >
                <Row className="align-items-center">
                  <Col>
                    <Tooltip
                      color="#fff"
                      background="black"
                      content="Specification (Drawing, COTS, Kit, Installation manual, Design & Engineering Guide): New number or revision change e.g. From None - New document To M12125 e.g. From P28412345 Rev A To: P28412345 Rev B"
                    >
                      <Form.Label>Documentation (Specification) Changes</Form.Label>
                    </Tooltip>
                  </Col>
                  <Col className="text-right">
                    <Button className="my-3" onClick={handleAddDocSpecFields}>
                      <i className="fas fa-plus"></i>Add New Specification
                    </Button>
                  </Col>
                </Row>
                <Row style={{ textAlign: "center",marginLeft:"-10px",marginRight:"-10px" }}>
                  <Table bordered hover responsive className="table-sm">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>DOCUMENT CHANGED FROM</th>
                        <th>DOCUMENT CHANGED TO</th>
                        <th>ATTACH FILE</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {docSpecFields && docSpecFields.length > 0
                        ? docSpecFields.map(({id, documentChangedFrom, documentChangedTo, file}, index) => (
                            <tr key={id}>
                              <td>{index + 1}</td>
                              <td>
                                <TextField
                                  style={{ width: "100%" }}
                                  name="documentChangedFrom"
                                  label="Document Changed (From)"
                                  maxRows={3}
                                  multiline
                                  id="standard-basic"
                                  value={documentChangedFrom}
                                  onChange={(event) =>
                                    handleChangeDocSpecInput(
                                      id,
                                      event
                                    )
                                  }
                                />{" "}
                              </td>
                              <td>
                                <TextField
                                  style={{ width: "100%" }}
                                  name="documentChangedTo"
                                  label="Document Changed (To)"
                                  maxRows={3}
                                  multiline
                                  id="standard-basic"
                                  value={documentChangedTo}
                                  onChange={(event) =>
                                    handleChangeDocSpecInput(
                                      id,
                                      event
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Form.Group controlId="file">
                                  {file ? <><a href={serverURL + encodeURIComponent(file?.filename)} target="_blank" rel="noopener noreferrer" download>{file?.filename}</a><hr /></> : <></>}
                                  
                                  <Form.File
                                    id="file"
                                    onChange={(e) =>
                                      uploadFileHandlerCustom(e, id)
                                    }
                                  ></Form.File>
                                  {uploading ? <Loader /> : null}
                                </Form.Group>
                              </td>
                              <td>
                                <Button
                                  variant="danger"
                                  className="btn-sm mx-1 my-1"
                                  onClick={() =>
                                    handleRemoveDocSpecFields(id)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </Button>
                              </td>
                            </tr>
                          ))
                        : null}
                    </tbody>
                  </Table>
                </Row>
              </Form.Group>
            ) : null}
            <Row>
              <Col>
                <Button
                  variant="primary"
                  style={{ margin: "10px 10px 10px 0" }}
                  onClick={saveHandler}
                >
                  Save
                </Button>
                {isSubmitted ?
                taskFieldsCheck ? <Button variant="primary" onClick={assignHandler}>Assign</Button> : null
                : <Button variant="primary" onClick={submitHandler}>Submit</Button>}
              </Col>
            </Row>
            <Row>
              <Col>
                {action?.message ? <Message variant="success">{action?.message}</Message> : null}
                {action?.error ? <Message variant="danger">{action?.error}</Message> : null}
              </Col>
            </Row>
          </Form>
          <Row
            style={{
              padding: "10px",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
              color: "black",
              fontSize: "1.2rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              Status -
              <span className="">
                <b> {activeStep && activeStep.name ? activeStep.name.toUpperCase() : null}</b>
              </span>
            </div>
            <Row>
              {
                requestActionId && approveButtonCheck ?
                  <Tooltip
                    color="#fff"
                    background="black"
                    content={`Give ${REQUEST_PHASES[progress.currentStep+1]} to the request`}
                  >
                  <Button
                    variant="primary"
                    style={{ margin: "10px" }}
                    onClick={() => approveModalHandler(requestActionId)}
                  >APPROVE</Button>
                  </Tooltip>
                  : null
              }
              {
                requestActionId && withdrawButtonCheck ?
                  <Tooltip
                    color="#fff"
                    background="black"
                    content={`Withdraw the request to ${REQUEST_PHASES[progress.currentStep-1]}`}
                  >
                  <Button
                    variant="primary"
                    style={{ margin: "10px" }}
                    onClick={() => withdrawModalHandler(requestActionId)}
                  >WITHDRAW</Button>
                  </Tooltip> : null
              }
              {requestActionId ? (
                  <Tooltip
                    color="#fff"
                    background="black"
                    content="Post a comment"
                  >
                  <Button
                    variant="primary"
                    style={{ margin: "10px" }}
                    onClick={() => commentsModalHandler(requestActionId)}
                  >COMMENT</Button>
                  </Tooltip>
              ) : null}
              </Row>
          </Row>
        <>
          <Modal
            show={withdrawModalShow}
            onHide={() => setWithdrawModalShow(false)}
          >
            <Modal.Dialog>
              <Modal.Header closeButton>
                <Modal.Title>Withdraw the request to {REQUEST_PHASES[progress.currentStep-1]} ?</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <ModalForm
                  changeInput={(withdrawNote) => setWithdrawNote(withdrawNote)}
                />
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setWithdrawModalShow(false)}
                >
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={withdrawHandler}
                >
                  Withdraw
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal>
          <Modal
            show={approveModalShow}
            onHide={() => setApproveModalShow(false)}
          >
            <Modal.Dialog>
              <Modal.Header closeButton>
                <Modal.Title>
                  Give {REQUEST_PHASES[progress.currentStep + 1]} to the Request ?
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <ModalForm
                  changeInput={(approveNote) => setApproveNote(approveNote)}
                />
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setApproveModalShow(false)}
                >
                  Close
                </Button>
                <Button
                  variant="success"
                  onClick={approveHandler}
                >
                  Approve
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal>
          <Modal
            show={commentsModalShow}
            onHide={() => setCommentsModalShow(false)}
          >
            <Modal.Dialog>
              <Modal.Header closeButton>
                <Modal.Title>Add Comments for the Request ?</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <ModalForm
                  changeInput={(commentNote) => setCommentNote(commentNote)}
                />
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setCommentsModalShow(false)}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={commentsHandler}
                >
                  Send
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal>
        </>
      </FormContainer>
    </div>
  );
};

export default RequestEditScreen;
